import httpRequest from "@/core/http-request";

//数据请求
export const authApi = {
    login(userInfo){
        return httpRequest.get('/auth/login', { params: userInfo });
    },
    logout(){
        return httpRequest.get('/auth/logout');
    }
}